import * as React from 'react';
import { Spin } from 'antd';
import styled, { css } from 'styled-components';
import NoData from '../NoData';

export interface SpinContainerProps extends GetProps<typeof Spin> {
  empty?: boolean | GetProps<typeof NoData>;
  autoHeight?: boolean;
}

const Outer = styled.div<{ $autoHeight?: boolean }>`
  height: 100%;
  flex: 1;

  .gm-ant-spin-nested-loading,
  .gm-ant-spin-container {
    height: 100%;
  }

  ${({ $autoHeight }) =>
    $autoHeight
      ? css`
          .gm-ant-spin-nested-loading > div > .gm-ant-spin {
            max-height: unset;
          }
        `
      : ''}
`;

const SpinContainer = ({ autoHeight, empty, children, ...props }: SpinContainerProps) => (
  <Outer $autoHeight={autoHeight}>
    <Spin {...props}>
      {empty ? <NoData {...(typeof empty === 'object' ? empty : {})} /> : children}
    </Spin>
  </Outer>
);

export default SpinContainer;
